// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"c1a570ab","511":"7aacc068","598":"45514701","787":"b62309d3"}[chunkId] + ".chunk.js";
};